import { Review } from "./review.model";


export interface Account {
  id: number;
  firstname: string;
  lastname: string;
  phoneVerifiedAt?: string;
  emailVerifiedAt?: string;
  email?: string;
  phoneNumber?: string;
  wallet?: number;
}

export interface PaymentMethod {
  id: number;
  type: string;
  name: string;
  createdAt: string;
}

export interface SubscriptionPlan {
  createdAt: string;
  updatedAt: string;
  id: number;
  name: string;
  description: string;
  price: number;
  duration: string;
}

export interface Subscription {
  id: number;
  plan: SubscriptionPlan;
  startTime: string;
  endTime: string;
  price: number;
  paymentMethod: PaymentMethod;
}

export interface Partner {
  id: number;
  name: string;
  representativeFirstName?: string;
  representativeLastName?: string;
  country?: string;
  countryId?: string;
  region?: string;
  regionId?: string;
  districtId?: string;
  houseNumber?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  contacts?: Record<string, string>;
  languagesSpoken?: string[];
  account?: Account;
  coverUrl?: string;
  coverUrlThumbnail?: string;
  status?: PartnerStatus;
  review?: any;
  topReview?: any;
  description?: string;
  verifiedAt?: string;
  district?: string;
  subscription?: Subscription;
  partnerEnabled?: boolean;
  vat?: string;
  allReviews?: Review[];
  averageRate?: number;
  homeNumber?: string;
  whatsapp?: string;
  website: string;
  twitterLink?: string;
  fbLink?: string;
  igLink?: string;
  liLink?: string;
  ytLink?: string;
  reviewsCount?: number;
  isVerified?: boolean;
  companyName?: string;
  phoneNumber?: string;
  email?: string;
  pendingEmail?: string;
  imagesUrl?: string[];
  licensePhotoUrl?: string;
  accountEnabled?: boolean;
  accountEmailVerifiedAt?: string;
  accountPhoneVerifiedAt?: string;
  qrCodeBase64?: string;
  holidayModeEnabledAt?: string;
  hideWalletAmount?: boolean;
  rejectionMotivation?: string;
  suspensionMotivation?: string;
  createdAt?: string;
  organicTermsAcceptedAt?: string | null;
  subscriptionTermsAcceptedAt?: string | null;
  termsAcceptedAt?: string | null;
  deletionRequestedAt?: string | null;
  deletionScheduledAt?: string | null;
  deletedAt?: string | null;
}

/** Stato della cancellazione account (GET/DELETE /v1/partner/account, POST .../deletion/cancel). */
export interface AccountDeletionStatus {
  status: PartnerStatus;
  deletionRequestedAt?: string | null;
  deletionScheduledAt?: string | null;
  graceDays: number;
  unpaidTotal?: number | null;
  paymentInProgress: boolean;
  canRequest: boolean;
  blockingReason?: string | null;
}

export enum PartnerStatus {
  PENDING = 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  UPDATE_REQUIRED = 'UPDATE_REQUIRED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  SUSPENDED = 'SUSPENDED',
  PENDING_DELETION = 'PENDING_DELETION',
  DELETED = 'DELETED'
}
